export function stripRuleSetRules(rules) {
    return (rules || []).map(stripRuleSetRule)
}

export function stripRuleSetRulesForCache(rules) {
    return (rules || []).map(stripRuleSetRuleForCache)
}

function stripRuleSetRule({ __typename, conditions, action, ruleSetName: __ruleSetName, ...rest }) {
    return {
        ...rest,
        conditions: (conditions || []).map(stripRuleSetCondition),
        action: action ? stripRuleSetAction(action) : action,
    }
}

function stripRuleSetRuleForCache({ __typename, conditions, action, ...rest }) {
    return {
        ...rest,
        conditions: (conditions || []).map(stripRuleSetCondition),
        action: action ? stripRuleSetAction(action) : action,
    }
}

function stripRuleSetCondition({ __typename, _id: __id, ...condition }) {
    return condition
}

function stripRuleSetAction({ __typename, ...action }) {
    return action
}
